import { CompanyConfig, TimeFormat } from '../interface';

// TODO: need update!!!
export const HeimkaupConfig: CompanyConfig = {
  id: '8b4b64e1-0e88-4889-b75a-1367bfb9baea',
  lang: 'is',
  langs: ['is', 'en', 'pl'],
  name: 'Heimkaup',
  nameSecondary: 'Heimkaup',
  currency: '',
  officialName: 'Heimkaup',
  email: 'info@icelandictrading.is',
  feedbackEmail: 'info@icelandictrading.is',
  phonePlaceholder: '+354',
  defaultPhoneCode: '+354',
  phoneNumber: '+354 416 9006',
  ageRestricted: 21,
  timeZone: 'Atlantic/Reykjavik',
  minimalOrderFeeThreshold: 700,
  address: 'Faxafen 14, 108 Reykjavík, Iceland',
  canonical: '',
  defaultVolumeDisplay: '1x',
  warehouse: {
    default: 'HEIMP',
    minimalOrderFeeWarehouseCodes: [],
    location: {
      lat: 64.12863593750646,
      lng: -21.864392115540912,
    },
  },
  map: {
    center: { lat: 64.12863593750646, lng: -21.864392115540912 },
    zoom: 12,
  },
  paymentMethods: ['applepay'],
  timeFormat: TimeFormat.h24,
  links: {
    cookie: '',
    deliveryZones: '',
    forRiders: '',
    // whatsapp: 'https://wa.me/971501515042',
    facebook: 'https://www.facebook.com/heimkaup/',
    instagram: 'https://www.instagram.com/heimkaup.is/',
    // tiktok: 'https://www.tiktok.com/@citydrinksuae/',
    // youtube: 'https://www.youtube.com/channel/UCzwC746u4WxzAs0fPOMfSMA/',
    affiliateProgram: import.meta.env.REACT_APP_AFFILIATE_PROGRAM_LINK,
    legals: {
      cookiePolicy: {
        label: 'cookiePolicy',
        link: '/legals#cookie-policy',
      },
      paymentAndDeliveryPolicy: {
        label: 'paymentAndDeliveryPolicy',
        link: '/legals#payment-and-delivery',
      },
      privacyPolicy: {
        label: 'privacyPolicy',
        link: '/legals#privacy-policy',
      },
      salesAndReturnPolicy: {
        label: 'salesAndReturnPolicy',
        link: '/legals#sales-and-returns-policies-and-consumer',
      },
      generalTradingPolicy: {
        label: 'generalTradingPolicy',
        link: '/legals#terms-of-service',
      },
    },
  },
  referral: {
    code: 'SWIFFTUCDAVIS',
    discount: '15%',
    minBasket: '15',
    downloadAppLink: 'https://click.jiffy.shop/PZKk/f11c621',
  },
  points: {
    value: '1=1c.',
    pointsPerUnit: 15,
    icon: 'coins',
  },
  appStoreUrl: {
    ios: '',
    android: '',
  },
  apis: {},
  countryCode: 'IS',
  license: {
    name: 'Heimkaup',
    numberPrinary: '',
  },
};
